import { put, call, select, takeLatest } from 'redux-saga/effects';
import { notification } from 'antd';
import { push } from 'connected-react-router';
import FileSaver from 'file-saver';
import ApiService from '../Services/ApiService';
import AppActions from '../Stores/App/Actions';
import WhseJob1401IndexActions, { WhseJob1401IndexTypes } from '../Stores/WhseJob1401Index/Actions';

const getAppStore = state => state.app;

export function* whseJob1401IndexFetchWhseJob1401Index({ currentPage, sorts, filters, pageSize }) {
  try {
    yield put(WhseJob1401IndexActions.whseJob1401IndexFetchWhseJob1401IndexLoading(true));

    const processedSorts = [];
    Object.entries(sorts).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      processedSorts.push(`${key}:${value === 'ascend' ? 'ASC' : 'DESC'}`);
    });

    const processedFilters = [];
    Object.entries(filters).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      if (value) {
        processedFilters.push(`${key}:${value}`);
      }
    });

    const app = yield select(getAppStore);
    const getData = {
      page: currentPage,
      sorts: processedSorts,
      filters: processedFilters,
      pageSize
    };

    const result = yield call(
      ApiService.getApi, // function
      app.apiUrl,
      `whseJob/indexWhseJob1401/${app.curSiteFlowId}`,
      app.token,
      getData,
      'multipart/form-data' // params
    );

    if (result.isSuccess === true) {
      // if nowCurrentPage is more than lastPage, then nowCurrentPage = lastPage
      let nowCurrentPage = result.data.current_page;
      if (nowCurrentPage > result.data.last_page) {
        nowCurrentPage = result.data.last_page;
      }

      yield put(
        WhseJob1401IndexActions.whseJob1401IndexFetchWhseJob1401IndexSuccess(
          result.data.data,
          nowCurrentPage,
          result.data.last_page,
          result.data.total,
          result.data.per_page
        )
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(WhseJob1401IndexActions.whseJob1401IndexFetchWhseJob1401IndexLoading(false));
  }
}

export function* whseJob1401IndexGoToWhseJobDocument({ hdrId }) {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/whseJob14Detail/update/${hdrId}`));
}

export function* whseJob1401IndexGoToAudit({ hdrId }) {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/auditResource/WHSE_JOB/${hdrId}/WhseJobHdr`));
}

export function* whseJob1401IndexGoToPrint({ document }) {
  try {
    yield put(WhseJob1401IndexActions.whseJob1401IndexFetchWhseJob1401IndexLoading(true));

    const app = yield select(getAppStore);

    const getData = {
      hdrIds: [document.id]
    };

    const result = yield call(
      ApiService.downloadGetApi, // function
      app.apiUrl,
      `whseJob/printProcess/WHSE_JOB_14_01/${app.curSiteFlowId}`,
      app.token,
      getData,
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    );

    if (result.isSuccess === true) {
      FileSaver.saveAs(result.data, `WhseJob1401_${document.doc_code}.pdf`);
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(WhseJob1401IndexActions.whseJob1401IndexFetchWhseJob1401IndexLoading(false));
  }
}

export const saga = [
  takeLatest(
    WhseJob1401IndexTypes.WHSE_JOB1401_INDEX_FETCH_WHSE_JOB1401_INDEX,
    whseJob1401IndexFetchWhseJob1401Index
  ),
  takeLatest(
    WhseJob1401IndexTypes.WHSE_JOB1401_INDEX_GO_TO_WHSE_JOB_DOCUMENT,
    whseJob1401IndexGoToWhseJobDocument
  ),
  takeLatest(WhseJob1401IndexTypes.WHSE_JOB1401_INDEX_GO_TO_PRINT, whseJob1401IndexGoToPrint),
  takeLatest(WhseJob1401IndexTypes.WHSE_JOB1401_INDEX_GO_TO_AUDIT, whseJob1401IndexGoToAudit)
];
